import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class BusinessCategoriesService {
  constructor(private http: HttpClient) {}

  public fetchBusinessCategories(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/businessCategory/list`
    return this.http.post(url, params)
  }

  public fetchBusinessCategory(id: number, params: any = {}): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/businessCategory/${id}`
    return this.http.get(url, params)
  }

  public deleteBusinessCategory(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/businessCategory/${id}`
    return this.http.delete(url)
  }

  public deleteBusinessSubcategory(cid: number, id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/businessCategory/subcategory/${id}`
    return this.http.delete(url)
  }

  public createBusinessCategory(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/businessCategory`
    return this.http.post(url, params)
  }
  public createBusinessSubcategory(
    id: number,
    params: object,
  ): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/businessCategory/${id}/subcategory`
    return this.http.post(url, params)
  }

  public updateBusinessCategory(id: number, params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/businessCategory/${id}`
    return this.http.put(url, params)
  }

  public fetchBusinessSubcategory(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/businessCategory/subcategory/${id}`
    return this.http.get(url, {})
  }

  public updateBusinessSubcategory(
    id: number,
    params: object,
  ): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/businessCategory/subcategory/${id}`
    return this.http.put(url, params)
  }
}
